import React from 'react'

import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import Typography from '@material-ui/core/Typography'
import { withStyles, createStyles, WithStyles, Theme } from '@material-ui/core'

import { MatchesResponse, IMatch } from 'protos'

import MatchCard from 'components/MatchCard'

// import MatchListItem from './components/MatchListItem'

interface Props {
  competition: MatchesResponse.ICompetitionGroup
  onMatchSelect: (matchId: string) => void
}

const styles = (theme: Theme) => createStyles({
  root: {
    flex: 1
  },
  title: {
    flex: 1,
    fontSize: 14,
    fontWeight: 700, // TODO theme.typography.fontWeightBold
    marginBottom: theme.spacing() * 2
  },
  listItem: {
    padding: 0,
    marginTop: theme.spacing() * 2,
    marginBottom: theme.spacing() * 2,

    '&:hover': {
      background: 'transparent'
    }
  },
  matchItem: {
    flex: 1
  }
})

type InjectedProps = Props & WithStyles<typeof styles>

const MatchCompetitionGroup: React.SFC<InjectedProps> = ({ classes, competition, onMatchSelect }) => {
  if (!competition.match) {
    return null
  }

  return (
    <div className={classes.root}>
      <Typography align="center" className={classes.title} gutterBottom>
        {competition.competition!.name}
      </Typography>

      <List disablePadding>
        {competition.match.map((match: IMatch, i) => (
          <ListItem
            button
            key={match.matchId || i}
            className={classes.listItem}
            onClick={() => onMatchSelect(match.matchId!)}
          >
            <MatchCard
              match={match}
              className={classes.matchItem}
            />
          </ListItem>
        ))}
      </List>
    </div>
  )
}

export default withStyles(styles)(MatchCompetitionGroup)
